import { useEffect } from 'react';

import { useAppSelector } from '@app/hooks';

import { resolveTheme } from '../theme';
import { selectThemeMode } from '../uiSlice';

const AUTO_RECHECK_MS = 60_000;

/** Writes the resolved theme to <html data-theme>; re-checks every minute in Auto mode
 *  so the switch to dark at 19:00 happens without a reload. */
export function ThemeSync() {
  const mode = useAppSelector(selectThemeMode);

  useEffect(() => {
    const apply = () => {
      document.documentElement.dataset.theme = resolveTheme(mode);
    };
    apply();
    if (mode !== 'auto') return undefined;
    const id = window.setInterval(apply, AUTO_RECHECK_MS);
    return () => {
      window.clearInterval(id);
    };
  }, [mode]);

  return null;
}
